import apiFetch from '../apiFetch'

export default function (idTipoInstalacion, token) {
  return apiFetch({endPoint: `TipoInstalacion/getTipoInstalacionCambioEstado`, method: 'POST', body: {idTipoInstalacion}, token: token})
}
